export default "__VITE_ASSET__DRsEK4Zf__"